/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PostPutReminderSettingRequestAdmin } from '../models/PostPutReminderSettingRequestAdmin';
import type { ReminderSettingAdminDto } from '../models/ReminderSettingAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ReminderSettingsService {
    /**
     * **Required Policy:** `ViewReminderSettings`
     * @returns ReminderSettingAdminDto OK
     * @throws ApiError
     */
    public static getReminderSettingsAdmin(): CancelablePromise<ReminderSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/remindersettings',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageReminderSettings`
     * @returns ReminderSettingAdminDto OK
     * @throws ApiError
     */
    public static postReminderSettingAdmin({
        requestBody,
    }: {
        requestBody?: PostPutReminderSettingRequestAdmin,
    }): CancelablePromise<ReminderSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/remindersettings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
